import React, { useState } from "react";
import "./Career.css";
import { IoIosArrowDropdownCircle, IoIosArrowDropupCircle } from "react-icons/io";

const jobs = [
  {
    title: "Digital Marketing Internship",
    description: [
      "Strong interest in digital marketing and online advertising",
      "Basic understanding of SEO, SEM, and social media marketing",
      "Assist in creating, scheduling, and managing content for different platforms",
      "Support in running paid campaigns on Google, Facebook, and Instagram",
      "Help monitor analytics, traffic, and engagement metrics",
      "Good communication skills and creativity in content ideas",
      "Eagerness to learn new marketing tools and strategies",
      "Ability to work in a team and follow instructions",
    ],
  },
  {
    title: "Data Entry officer ( Finance )",
    description: [
      "Minimum 1-2 years of data entry or clerical experience (Finance background preferred)",
      "Accurately enter, update, and maintain financial records in databases",
      "Verify and reconcile invoices, receipts, and transaction details",
      "Proficiency in Microsoft Excel and accounting software",
      "Maintain confidentiality of sensitive financial information",
      "Strong attention to detail and accuracy",
      "Ability to work under deadlines with efficiency",
      "Basic knowledge of bookkeeping and financial reporting",
    ],
  },
  {
    title: "Finance Manager",
    description: [
      "Minimum 3-5 years of finance and accounting experience",
      "Oversee financial planning, budgeting, and forecasting",
      "Prepare and analyze financial statements and reports",
      "Ensure compliance with financial regulations and company policies",
      "Manage cash flow, investments, and risk management",
      "Provide insights for business growth and profitability",
      "Supervise and guide the finance team",
      "Strong knowledge of taxation, auditing, and financial modeling",
      "Proficiency in financial software and MS Excel",
    ],
  },
  {
    title: "Sales Officer",
    description: [
      "Minimum 2 years of sales experience in a relevant field",
      "Identify new sales opportunities and generate leads",
      "Build and maintain relationships with clients",
      "Achieve monthly and quarterly sales targets",
      "Excellent communication and negotiation skills",
      "Prepare and present sales proposals to potential clients",
      "Collaborate with the marketing team for promotional activities",
      "Provide feedback to management regarding market trends",
      "Ability to work under pressure and meet deadlines",
    ],
  },
  {
    title: "Cashier",
    description: [
      "Minimum 1-2 years of experience in cashiering or retail operations",
      "Handle cash, credit, and digital payments accurately",
      "Issue receipts, refunds, and change to customers",
      "Balance cash drawer at the end of each shift",
      "Maintain accurate financial transactions and records",
      "Provide excellent customer service and resolve billing queries",
      "Follow company policies for handling money securely",
      "Basic knowledge of accounting and POS systems",
    ],
  },
];


const Career = () => {
  const [activeJob, setActiveJob] = useState(null);

  const toggleJob = (index) => {
    setActiveJob(activeJob === index ? null : index);
  };

  return (
    <div className="career-page">
      {/* Hero */}
      <section className="career-hero">
        <div className="hero-overlay">
          <h1>Join Our Team</h1>
          <p>Be part of a vibrant, growing company and shape your career with us!</p>
        </div>
      </section>

      {/* Content */}
      <section className="career-content">

                <div className="job-listings">
                {jobs.map((job, idx) => (
                    <div
                    key={idx}
                    className={`job-card ${activeJob === idx ? "active" : ""}`}
                    onClick={() => toggleJob(idx)}
                    >
                    <div className="job-header">
                        <h3>{job.title}</h3>
                        <span className="job-toggle-icon">
                        {activeJob === idx ? (
                            <IoIosArrowDropupCircle size={22} />
                        ) : (
                            <IoIosArrowDropdownCircle size={22} />
                        )}
                        </span>
                    </div>
                    {activeJob === idx && (
                        <ul className="job-details">
                        {job.description.map((desc, i) => (
                            <li key={i}>{desc}</li>
                        ))}
                        </ul>
                    )}
                    </div>
                ))}
                </div>


        <div className="apply-form">
          <h2>Apply Now</h2>
          <p>Start your journey with us. Upload your resume and get hired!</p>
          <form>
            <label className="upload">
              Upload Resume
              <input type="file" />
            </label>
            <input type="text" placeholder="Full Name" required />
            <input type="email" placeholder="Email" required />
            <input type="tel" placeholder="Phone Number" required />
            <button type="submit">Submit Application</button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default Career;
